export var SplitButtonStylePropertiesByVariantAndSize = {
    default: {
        xsmall: {},
        small: {},
        medium: {},
        large: {},
    },
    outlined: {
        xsmall: {
            height: '20px',
            childHeightOverride: '18px',
        },
        small: {
            height: '24x',
            childHeightOverride: '22px',
        },
        medium: {
            height: '32px',
            childHeightOverride: '30px',
        },
        large: {
            height: '40px',
            childHeightOverride: '38px',
        },
    },
    ghost: {
        xsmall: {},
        small: {},
        medium: {},
        large: {},
    },
};
//# sourceMappingURL=SplitButtonStylePropertiesByVariantAndSize.js.map